import TopicLayoutWrapper from './TopicLayoutWrapper';

export default TopicLayoutWrapper;
